import {
    TableHead,
    TableRow,
    TableCell,
    Checkbox,
    TableSortLabel,
    Box,
} from "@mui/material";
import { ChangeEvent, MouseEvent } from "react";
import { IColumn, TData } from "../DataTable";
import { visuallyHidden } from "@mui/utils";

export type Order = "asc" | "desc";

interface HeaderProps<T> {
    numSelected: number;
    onRequestSort: (event: MouseEvent<unknown>, property: keyof T) => void;
    onSelectAllClick: (event: ChangeEvent<HTMLInputElement>) => void;
    order: Order;
    orderBy: string;
    rowCount: number;
    columns: IColumn<T>[];
    checkable: boolean;
}

const Header = <T extends Object>(props: HeaderProps<TData<T>>) => {
    const {
        onSelectAllClick,
        order,
        orderBy,
        numSelected,
        rowCount,
        onRequestSort,
        columns,
        checkable,
    } = props;
    const createSortHandler =
        (property: keyof T) => (event: MouseEvent<unknown>) => {
            onRequestSort(event, property);
        };

    return (
        <TableHead>
            <TableRow>
                {checkable && (
                    <TableCell padding="checkbox">
                        <Checkbox
                            color="primary"
                            indeterminate={
                                numSelected > 0 && numSelected < rowCount
                            }
                            checked={rowCount > 0 && numSelected === rowCount}
                            onChange={onSelectAllClick}
                            inputProps={{
                                "aria-label": "select all",
                            }}
                        />
                    </TableCell>
                )}
                {columns.map((headCell) => (
                    <TableCell
                        key={headCell.headerName}
                        align={headCell.align}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={
                            orderBy === headCell.field ? order : false
                        }
                    >
                        <TableSortLabel
                            active={orderBy === headCell.field}
                            direction={
                                orderBy === headCell.field ? order : "asc"
                            }
                            onClick={createSortHandler(
                                headCell.field as keyof T
                            )}
                        >
                            {headCell.headerName}
                            {headCell.renderHeader}

                            {orderBy === headCell.field ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === "desc"
                                        ? "sorted descending"
                                        : "sorted ascending"}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default Header;
